export default __webpack_public_path__ + "static/media/harmay-iphone1.41c4ac66.png";